// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__ruK6w","file":"styles_file__209RK"};